import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import {
  getCustomer
} from "../helpers";

const SideBar = () => {

  let userId = getCustomer();

  const navigate = useNavigate();

  const logout = (ev) => {
    localStorage.clear();
    window.location.href = "/";
  }

  if(userId === ""){
    return (
      <div className="side--bar">
      </div>
    )
  }else{
    return (
      <div className="side--bar">
        <Link className="side--bar--item" to='/myAccount'>
          My Account
        </Link>
        <Link className="side--bar--item" to='/mySubscriptions'>
          Subscriptions
        </Link>
        <Link className="side--bar--item" to='/myVirtualSpaces'>
          My Virtual Spaces
        </Link>
        <Link className="side--bar--item" to='/billingActivity'>
          Billing &amp; Payments
        </Link>
        <a type="button" onClick={ev => logout(ev)} className="side--bar--item">Logout</a>
      </div>
    )
  }
}

export default SideBar;